export function buildConnectionUrl(routeMapper, hostUrl, page, hash) {
  let routerUrl = isQAUrl(hostUrl) ? routeMapper['auto1-test.com'] : routeMapper[hostUrl];
  if (!routerUrl) {
    throw new Error("No route found for hostUrl: " + hostUrl);
  }
  const connectionUrlParams = buildConnectionUrlParams(page, hash);
  return routerUrl.includes('?') ? routerUrl + "&" + connectionUrlParams : routerUrl + "?" + connectionUrlParams;
}
export function buildMessage(_ref) {
  let {
    type,
    hash,
    page,
    returningUser
  } = _ref;
  return {
    name: type,
    payload: {
      hash,
      returningUser
    },
    page,
    referrer: "" + window.location.href
  };
}
function isQAUrl(url) {
  return url.includes('auto1-test.com');
}
function buildConnectionUrlParams(page, hash) {
  return new URLSearchParams({
    name: 'user-disconnected',
    page,
    hash,
    referrer: window.location.href
  }).toString();
}
//# sourceMappingURL=utils.js.map